export default __webpack_public_path__ + "static/media/2235.4bba8be6.png";